module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_base_badge-9563f187164b8109641e9e71e067da40.png";